export default "assets/images/icons/pinterest-8ef21743.svg";